import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "shared/utils/fetch-api";
import parseToTimestamp from "shared/utils/parseToTimestamp";

export const fetchDirectory = createAsyncThunk(
    'contract/fetchDirectory',
    async (_, { rejectWithValue }) => {
        try {
            const response = await getRequest({}, 'dms-hr', 'getDirectories', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { themes: data.Directories.Themes, priorities: data.Directories.Priorities, fetchTime: parseToTimestamp(new Date())};
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);